import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Button, Col, Form, Row, Select, Space, Spin, Table, Tag } from 'antd';
import { Link, RouteComponentProps } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getSession } from 'app/shared/reducers/authentication';
import { getSortState, JhiItemCount, JhiPagination, Storage, TextFormat } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import { getAllApprovisonnements } from './appro.reducer';
import { DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';

const FondDashboard = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();
  const allAppros = useAppSelector(state => state.approvisonnement.entities);
  const loading = useAppSelector(state => state.approvisonnement.loading);
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const filteredAppros = allAppros;
  const totalItems = useAppSelector(state => state.approvisonnement.totalItems);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  useEffect(() => {
    dispatch(getSession());
    sortEntities();
  }, []);

  const handlePagination = (currentPage: number) => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  const handleDownload = async id => {
    await axios({
      url: `/api/approvisonnement/${id}/file`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    })
      .then(response => {
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
      })
      .catch(error => console.error("Erreur lors de l'ouverture du fichier PDF :", error));
  };

  const approvisonnementList = () => {
    const entity = {
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getAllApprovisonnements(entity));
  };

  const sortEntities = () => {
    approvisonnementList();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  const { match } = props;
  const renderOptionDetails = (id, anneeScolaireId) => (
    <Space size="middle">
      <Button type="primary" style={{ height: 30, width: 45 }}>
        <Link to={`${match.url}/${anneeScolaireId}/${id}/details`}>
          <FontAwesomeIcon icon="eye" />{' '}
        </Link>
      </Button>
    </Space>
  );

  const column = [
    {
      title: 'Date et Heure',
      dataIndex: 'date',
      key: 'date',
      align: 'center' as const,
      render: date => <TextFormat type="date" value={date} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      title: 'Etablissements',
      dataIndex: 'ecole',
      key: 'ecole',
      align: 'center' as const,
    },
    {
      title: 'Montants',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Statuts',
      dataIndex: 'statutApprovisonnement',
      key: 'statutApprovisonnement',
      align: 'center' as const,
      render: statut =>
        statut === 'ENCOURS' ? (
          <Tag color="red">En attente</Tag>
        ) : statut === 'VALIDE' ? (
          <Tag color="green">Validé</Tag>
        ) : (
          <Tag color="#dc3545">Rejeté</Tag>
        ),
    },
    {
      title: 'Documents',
      key: 'documents',
      align: 'center' as const,
      render: (text, record) => (
        <DownloadOutlined
          style={{ fontSize: '24px', marginRight: '8px', verticalAlign: 'middle' }}
          onClick={() => handleDownload(record.id)}
        />
      ),
    },
    {
      title: 'Options',
      dataIndex: ['id', 'statut'],
      key: 'id',
      align: 'center' as const,
      render: (_, row) => renderOptionDetails(row['id'], row['anneeScolaireId']),
    },
  ];

  const dataSource = filteredAppros.map((approvisonnement, i) => ({
    id: approvisonnement.id,
    anneeScolaireId: approvisonnement.anneeScolaireId,
    date: approvisonnement.dateEmission,
    description: approvisonnement.description,
    ecole: approvisonnement.ecole ? approvisonnement.ecole.nom : '',
    montant: `${approvisonnement.montant} FCFA`,
    statutApprovisonnement: approvisonnement.statutApprovisonnement,
  }));

  const onSearch = vals => {
    const entity = {
      ...vals,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getAllApprovisonnements(entity));
  };

  const handleChange = () => {
    const entity = {
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getAllApprovisonnements(entity));
  };

  return (
    <div>
      <h2 className="center"> Approvisonnements</h2>
      <Form name="basic" layout="inline" onFinish={onSearch}>
        <Row className="p-1">
          <Col span={20} sm={20} md={20} xs={17} xxl={20} xl={20} lg={24}>
            <Form.Item name="statutApprovisonnement">
              <Select placeholder="Status" allowClear onClear={handleChange}>
                <Select.Option value="ENCOURS">
                  <Tag color="red">En attente</Tag>
                </Select.Option>
                <Select.Option value="VALIDE">
                  <Tag color="green">Validée</Tag>
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={1} sm={1} md={1} xs={1} xxl={1} xl={1} lg={3}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={column} dataSource={dataSource.reverse()} bordered pagination={false} style={{ textAlign: 'center' }} />
          </Spin>
        </div>
        {totalItems ? (
          <div className={allAppros && allAppros.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};
export default FondDashboard;
